var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Portlet',{attrs:{"title":_vm.$t('notify'),"sub-title":_vm.$t('smsView.sendMessage'),"icon":"flag"}},[_c('NotifyWizard',{attrs:{"installation-id":_vm.installationId,"recipient-id":_vm.recipientId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }